// F.18: co mówimy firmom o tokenach KSeF. MF zapowiedziało, że tokeny zostają także po 2026 r.
// (FAQ KSeF 2.0, pyt. 39), więc bez daty końca nikogo nie straszymy. Datę, gdyby jednak padła,
// trzyma jedna stała na serwerze (Login/backend/lib/ksef.js#KSEF_TOKEN_KONIEC), a panel dostaje
// ją w GET /api/ksef-settings jako `tokenSunset` (RRRR-MM-DD albo null).

function dzisYmd(teraz) {
  const p = (n) => String(n).padStart(2, '0');
  return `${teraz.getFullYear()}-${p(teraz.getMonth() + 1)}-${p(teraz.getDate())}`;
}

// 'brak' (nie znamy końca tokenów), 'przed' (koniec zapowiedziany) albo 'po' (już minął), z datą
// DD.MM.RRRR do komunikatu. Teksty wybiera ekran, żeby audyt tłumaczeń widział ich klucze.
export function stanTokenow(tokenSunset, teraz = new Date()) {
  if (typeof tokenSunset !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(tokenSunset)) return { stan: 'brak', data: null };
  const [r, m, d] = tokenSunset.split('-');
  return { stan: dzisYmd(teraz) >= tokenSunset ? 'po' : 'przed', data: `${d}.${m}.${r}` };
}
